import axios from "axios";

import { SET_BILLS_OF_LADING, SET_SHIPMENT_ROUTE } from "./types";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";

export const getBillsOfLading = createAsyncAction(
  resolve => (loadId, units) =>
    resolve(async dispatch => {
      dispatch({ type: SET_BILLS_OF_LADING, payload: {} });
      const lang = localStorage.getItem("language");
      const response = await axios.get(`${getApiUrl()}/load/${loadId}/shipment`, {
        params: {
          weightUOM: units.WEIGHT,
          lengthUOM: units.LENGTH,
          surfaceUOM: units.SURFACE,
          dimensionUOM: units.DIMENSION,
          lang
        }
      });
      dispatch({ type: SET_BILLS_OF_LADING, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_BILLS_OF_LADING, payload: {} })
);

export const getshipmentRouteStatuses = createAsyncAction(
  resolve => shipmentId =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = await axios.get(`${getApiUrl()}/shipment/${shipmentId}/route`, { params: { lang } });
      dispatch({ type: SET_SHIPMENT_ROUTE, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_SHIPMENT_ROUTE, payload: {} })
);



// WEBPACK FOOTER //
// ./src/actions/billsOfLadingActions.js